let indvTitles = [
    'Boarding FAQs',
    'Daycare FAQs',
    'Grooming FAQs',
    'Interested in being a part of The Biscuit Garden team?'
]

let boardingFaqs = [
    {
        title: 'What time is drop off and pick up for boarding?',
        info: ['You may drop off and pick up anytime during our open hours. We are open Monday - Saturday from 7am - 7pm and on Sunday from 4pm - 7pm. We charge by the night so there are no half day charges.']
    },
    {
        title: `Should I bring food from home?`,
        info: [`We offer a Holistic chicken and rice as our house food and although most pets do quite well with the transition, we recommend and prefer that you bring food from home to help reduce gastric upset. We do ask that all meals from home be placed in individual ziplock bags; one for each meal. Failure to pre package individual meals will result in a $2.00 fee per meal. If your pet will be staying with us for a longer than average period of time, you may discuss pre packaging options with us prior to your stay.`]
    },
    {
        title: `What should I bring for my pet’s boarding?`,
        info: [
            `You don’t need to bring anything! We provide all of the items that your pet will need during their stay. All bedding, toys and bowls of all shapes, sizes and materials are ready for them upon arrival.`, 
            `We have found that some dogs become possessive over personal items when in a new environment and in an effort to keep a safe and happy space, we ask that you leave all of those items at home. Each and every item that we provide is thoroughly sanitized, cleaned, fluffed and shined before your pet’s arrival and throughout their time with us. So pack their food, treats and medications (if needed) and leave the rest to us!`
        ]
    },
    {
        title: `Do you administer medications?`,
        info: [`Absolutely! We are happy to administer any medication that your pet requires during their stay. We do ask that all medication be provided in its original bottle with a label that includes the pet’s name, medication name and dosage. Please let us know at time of drop off if your pet requires medication during their stay and we will fill out a medication form together to insure that all information is correct.`, 
        `There is no fee for administering medications.`]
    },
    {
        title: `Can I add a Spa appointment to my pet’s boarding reservation?`,
        info: [`You sure can! We can add a nail trim and/or bath to your pet’s stay. Please let us know at time of drop off what service you would like added and what time you would like to pick them up so that we can maximize their play time and have them ready for you at pick up.`]
    },
    {
        title: `Is Doggie Daycare included with boarding?`,
        info: [`Yes! Play time is always included during your pet’s stay at no additional fee.`]
    },
    {
        title: `What is your Cancellation Policy for boarding?`,
        info: [
            `NON-HOLIDAY Cancellation Policy - Cancellations made 48 hours or more prior to the reservation are allowed with no penalty.  Any cancellation made within 48 hours of the reservation, including no shows, will be charged the full amount of the reservation.`,
            `HOLIDAY Cancellation Policy - Cancellations made 7 days or more prior to the reservation are allowed with no penalty.  Any cancellation made within 7 days and before 48 hours of the reservation will be charged 50% of the total reservation.  Any cancellations within 48 hours of the reservation, including no shows, will be charged the amount of the total reservation.`,
            `Holiday dates include: Easter week, Thanksgiving week, Christmas - New Years week, and Memorial Day Weekend - Labor Day Weekend ( this includes the entirety of summer)`
        ]
    },
    {
        title: ` Does my pet need to be evaluated prior to their boarding reservation?`,
        info: [
            `We do require that your pet attend a half or full day of daycare prior to their first boarding reservation. This will allow your pet the opportunity to be introduced to our facility and staff before their stay.`
        ]
    },
]

let daycareFaqs = [
    {
        title: 'What time is pick up and drop for daycare?',
        info: [
            `You may pick up and drop off anytime during our open hours. We are open from 7am- 7pm Monday - Saturday.`, 
            `Half day daycare options are either for the morning play groups or the afternoon play groups meaning that if you choose the half day morning play option, you can drop off and pick up anytime during 7am - 12pm. The half day afternoon play group drop off and pick up hours are anytime during 2pm - 7pm.`
        ]
    },
    {
        title: `What is your Cancellation Policy for daycare?`,
        info: [`Cancellations or rescheduling for daycare must be made no later than 9 AM the morning of the reservation. Failure to cancel or reschedule a daycare reservation will result in a charge to the credit card on file for either a full day or a half day, depending on the reservation made. Clients with packages will forfeit 1 day of their package.`]
    },
    {
        title: `Can I add a Spa day to my pet’s Daycare day?`,
        info: [`You sure can! We can add a nail trim and/or a bath to your pet’s day. Please let us know at time of drop off what service you would like added and what time you would like to pick them up so we can maximize their play time and have them ready for pick up.`]
    },
    {
        title: ` Does my pet need to be evaluated prior to attending daycare?`,
        info: [
            `Your pet will be evaluated on their first day of daycare and you will receive a report card at the end of the day to let you know how they did!`
        ]
    },
]

let groomingFaqs = [
    {
        title: 'Do you offer full grooming services?',
        info: [
            `At this time we only offer bath and nail trims for our guests. Your pet can receive a Fresh n’ Clean bath, oatmeal conditioner, fluff dry and cologne spritz.`, 
            `A FREE nail trim is always included with the purchase of a bath!`
    ]
    },
    {
        title: `How do you trim nails?`,
        info: [`We love doggies with short, smooth nails and know that you do too! Our expert pawdicurists use the grinding method to gently shorten the nails leaving them rounded and uniform with no sharp edges.`]
    },
    {
        title: `What is your Cancellation Policy for grooming?`,
        info: [`Failure to cancel or reschedule a grooming appointment prior to the appointment
        will result in the full amount charged to the credit card of file. Cancellations or
        rescheduling must be made no late than 9 AM the morning of the appointment.`]
    },
]

let joinTeamDropdown = [
    {
        info: [
            `Please send your resume to the thebiscuitgarden@gmail.com and tell us a little about yourself!`
    ],
    }
]

export {
    indvTitles,
    boardingFaqs,
    daycareFaqs,
    groomingFaqs,
   joinTeamDropdown,
}